import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { nav, site } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 border-b border-line bg-white/95 backdrop-blur" data-id="element-70" data-mp="2ni7l9p4xe1ol">
      <div className="hidden border-b border-line bg-ink text-white lg:block" data-id="element-71" data-mp="2rk2s195ml79r">
        <div className="mx-auto flex max-w-content items-center justify-between px-6 py-2 text-[13px]" data-id="element-72" data-mp="2wjfgfyc5ameg">
          <p className="text-white/70" data-id="element-73" data-mp="31cqo21os777f">
            Rails à rideaux — qualité et design européens depuis {site.since}
          </p>
          <div className="flex items-center gap-6" data-id="element-74" data-mp="3ba4rn0plw1ib">
            <a className="transition-colors duration-150 ease-smooth hover:text-signal" href={site.phoneHref} data-id="element-75" data-mp="3bbpowy3b1yjv">
              {site.phoneDisplay}
            </a>
            <a className="transition-colors duration-150 ease-smooth hover:text-signal" href={site.emailHref} data-id="element-76" data-mp="2wldw5nefh198">
              {site.email}
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-content items-center justify-between gap-6 px-6 py-4" data-id="element-77" data-mp="2mm54j171byq1">
        <Link to="/" className="flex items-center gap-3" aria-label={`${site.name} — accueil`} data-id="element-78" data-mp="2hntxszc1e4c1">
          <img src={site.logo} alt="Logo Goelst — European Quality &amp; Design" className="h-9 w-auto sm:h-11" width={220} height={64} data-id="element-79" data-mp="3fb2m123f9rhq" />
          <span className="sr-only" data-id="element-80" data-mp="35l0w04ridz06">{site.name}</span>
        </Link>

        <nav aria-label="Navigation principale" className="hidden items-center gap-8 lg:flex" data-id="element-81" data-mp="35j6dex3pmiz9">
          {nav.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `text-[15px] tracking-tight transition-colors duration-150 ease-smooth ${isActive ? 'text-signal' : 'text-ink-soft hover:text-ink'}`} data-id="element-82" data-mp="1wzb4ev6xjg4">
              {item.label}
            </NavLink>)}
        </nav>

        <div className="hidden lg:block" data-id="element-83" data-mp="1hnhz1jml4flc">
          <a href={site.phoneHref} className="inline-flex items-center gap-2 bg-ink px-5 py-3 text-[14px] font-medium text-white transition-colors duration-150 ease-smooth hover:bg-signal" data-id="element-84" data-mp="1mml7zf5or5yl">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-85" data-mp="1cpq7wrtrkxi7" />
            Demander un conseil
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-11 w-11 items-center justify-center border border-line text-ink lg:hidden" aria-expanded={open} aria-controls="menu-mobile" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-86" data-mp="yqgt9wl7ibgc">
          {open ? <XIcon className="h-5 w-5" data-id="element-87" data-mp="meeo44z7merc" /> : <MenuIcon className="h-5 w-5" data-id="element-88" data-mp="mfpqq1gx5ggv" />}
        </button>
      </div>

      {open && <div id="menu-mobile" className="border-t border-line bg-white lg:hidden" data-id="element-89" data-mp="hgcyf17a3h6w">
          <nav aria-label="Navigation mobile" className="mx-auto max-w-content px-6 py-2" data-id="element-90" data-mp="w4znhumpjnbb">
            {nav.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `block border-b border-line py-4 text-[17px] ${isActive ? 'text-signal' : 'text-ink'}`} data-id="element-91" data-mp="rczg5h4b5s4p">
                {item.label}
              </NavLink>)}
            <div className="grid gap-3 py-5" data-id="element-92" data-mp="1a3pkla9j1mzo">
              <a href={site.phoneHref} className="flex items-center justify-center gap-2 bg-ink px-5 py-4 text-[15px] font-medium text-white" data-id="element-93" data-mp="1a50ln2bl8gn3">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-94" data-mp="3bx6pi669w9qq" />
                {site.phoneDisplay}
              </a>
              <a href={site.emailHref} className="flex items-center justify-center border border-ink px-5 py-4 text-[15px] font-medium text-ink" data-id="element-95" data-mp="230roi1ro9qdi">
                {site.email}
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}